import { IRootProps } from "../../interfaces";

export default function LayoutPlansAndAppsCompanyForm({
  children,
}: IRootProps) {
  return <>{children}</>;
}
